import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { Transaction } from '../../models/transaction';
import { NavController } from '@ionic/angular';
import { BarcodeScannerOptions, BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-posm-pl9-create',
  templateUrl: './posm-pl9-create.page.html',
  styleUrls: ['./posm-pl9-create.page.scss'],
})
export class PosmPl9CreatePage implements OnInit {

  data = new Data();
  myId: any;
  user: any;
  model: Transaction[];
  dataSource: MatTableDataSource<Transaction>;

  displayedColumns: string[] = ['select','position', 'date', 'order', 'item'];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  searching = false;
  scannedData: any;
  barcodeScannerOptions: BarcodeScannerOptions;
  active = false;
  verify = false;
  error = false;
  ic: any;
  icx: any;
  trans: any;
  connote = [];
  click = [];
  pl9 = [];
  pl9no: any;

  constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, private barcodeScanner: BarcodeScanner, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {

    this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.data =  {
      id: 4,
      name: 'getCPCustomer',
      content: this.myId
    };

  }

  ngOnInit() {

    this.getCust();

    /*const ELEMENT_DATA: PeriodicElement[] = [
      {position: 1, name: 'Abc', weight: 1.0079, symbol: 'H'},
      {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
      {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
      {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
      {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
      {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
      {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
    ];*/

    

    /*this.apiService.postData(this.data).subscribe((response) => {
      this.product = response.data;
    });*/
  }

  getRecord(row) {
    console.log(row);
    this.router.navigate(['/members/posm/' + row.order + '/0']);
  }

  getCust() {
    this.searching = false;

    var dt1 = {
      id: localStorage.getItem('user')
    }

    this.data =  {
      id: 4,
      name: 'posTransactionConnote',
      content: dt1
    };

    console.log(this.data);

    this.apiService.postData(this.data).subscribe((response) => {

      this.searching = true;
      this.model = response.data;

        console.log(this.model);

        this.dataSource = new MatTableDataSource(this.model);

        console.log(this.dataSource);
        // this.dataSource.paginator = this.paginator;

        this.model.forEach(e => {
          this.connote.push(e.position);
          this.click.push(false);
        });


    });
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogTwelvePage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  getLimit() {
    if (this.myId === '126') {
      return 12;
    } else {
      return 14;
    }
  }

  tested(id) {
    console.log(this.getKey(id.position));
    if(this.click[this.getKey(id.position)] == false) this.click[this.getKey(id.position)] = true; else this.click[this.getKey(id.position)] = false;
  }

  createPl9() {
    // console.log(this.connote)
    // console.log(this.click);

    this.pl9 = [];

    for(var i=0; i < this.click.length; i++){
      if(this.click[i] == true) this.pl9.push(this.connote[i]);
    }




    var pl9_data = {
      id: 1,
      name: 'pl9',
      content: this.pl9
    };

    console.log(pl9_data);


    this.apiService.pos(pl9_data).subscribe((response) => {

      this.pl9no = response;

      console.log(this.pl9no);
      console.log(this.pl9no.PL9No);
      this.router.navigate(['/members/posm-pl9']);
      window.open("http://dexmart.dexasia.com.my/form/pl9.php?id=" + this.pl9no, "_blank");

    });
  }

  getKey(id) {

    for (var i = 0; i < this.connote.length; i ++) {
        if (id == this.connote[i]) return i;
    }

  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogTwelvePage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
